import { render } from "./PostitCard.vue?vue&type=template&id=2bb3530e&scoped=true"
import script from "./PostitCard.vue?vue&type=script&lang=js"
export * from "./PostitCard.vue?vue&type=script&lang=js"

import "./PostitCard.vue?vue&type=style&index=0&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=1&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=2&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=3&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=4&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=5&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=6&id=2bb3530e&scoped=true&lang=css"
import "./PostitCard.vue?vue&type=style&index=7&id=2bb3530e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb3530e"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QAvatar from 'quasar/src/components/avatar/QAvatar.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QField from 'quasar/src/components/field/QField.js';
import QRating from 'quasar/src/components/rating/QRating.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpace,QBtn,QTooltip,QSpinner,QDialog,QAvatar,QIcon,QInput,QCardActions,QField,QRating});qInstall(script, 'directives', {ClosePopup});
